import type { AxiosResponse } from 'axios'
import httpClient from 'modules/comments/api/http-client'

interface WorkspaceInterface {
  currentWorkspaceMembership: number | null
}

export const WORKSPACE_API = '/api/settings/workspace'
// TODO: sus
export const setWorkspace = (data: WorkspaceInterface): Promise<AxiosResponse> =>
  httpClient.post(WORKSPACE_API, data)
